module.exports = __webpack_public_path__ + "media/images/laptop-65adb3da7e82b2d5fdf17ca1c3aa597a.png";